import { determineTileMode } from "@/helpers/puzzleShare";
import type { GuessCell } from "@/types/puzzle";

/**
 * Converts raw numeric guesses into GuessGrid cells, using the same per-digit
 * color logic as puzzle score sharing and scoreboard rendering.
 */
export const convertStatsToGuessCell = (guesses: number[], actualPrice?: number): GuessCell[][] => {
    return guesses.map((guess) => {
        const guessStr = String(guess).padStart(8, "0");
        const actualStr = actualPrice ? String(actualPrice).padStart(8, "0") : "";

        return guessStr.split("").map((digit, index) => {
            let status: "correct" | "close" | "wrong" = "wrong";

            if (actualStr && actualStr[index]) {
                const guessDigit = parseInt(digit, 10);
                const actualDigit = parseInt(actualStr[index], 10);
                const mode = determineTileMode(actualDigit, guessDigit);
                if (mode === "correct") {
                    status = "correct";
                } else if (mode === "close") {
                    status = "close";
                }
            }

            return {
                digit,
                status,
            };
        });
    });
};
